let formatValidation = {};

formatValidation.email = (email) => {
  const re =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
  return re.test(email);
};

export const maxLength = (obj, maxLength) => {
  if (typeof obj === 'string') {
    return obj.length <= maxLength;
  } else if (typeof obj === 'number') {
    return ((Math.log(Math.abs(obj) + 1) * 0.43429448190325176) | 0) + 1 <= maxLength;
  }
  return false;
};

export default formatValidation;
